/**
This is the component to preview the files in the web page.
This support following type
1. Word
2. Excel
3. Power Point
4. Image
5. PDF

Properties :
@filePath : URL of the file which needs to be previewed
@type : file type, which should be one of the above defined.


How it workd
Component load the given file path into a iframe and either the native capability of the brower take care of the preview
or if the file type is word/excel/powerpoint then microsoft office app API are used for the preview purpose.


Example :

<FilePreviewer :title="pathVariable" :type="typeVariable"></FilePreviewer>

*/
<template>
  <div>
    <b-modal size="xl" v-model="isModalVisible" @hide="onClose()" :title="title">
      <div class="modal-body">
        <iframe ref="canvas" :src="fileSourcePath" width="100%" height="100%"/>
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="downloadFile()">Download</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { EventBus } from "../../EventBus";

const OFFICE_PREVIEW_PATH_URL =
  "https://view.officeapps.live.com/op/embed.aspx?src=";
export default {
  props: {
    filePath: { type: String },
    isVisible: { type: Boolean },
    title: { type: String },
    type: { type: String },
    metaData: { type: Object },
  },
  data() {
    return {
      fileSourcePath: "",
      isModalVisible: false,
    };
  },
  methods: {
    downloadFile() {
      this.$emit("onDownloadClick", this.metaData, this.title);
    },
    onClose() {
      this.$emit("hideModal", false);
      this.fileSourcePath = "";
    },
    createObjectUrlFromBinary(url) {
      return new Promise((resolve, reject) => {
        try {
          const req = new XMLHttpRequest();
          req.open("GET", decodeURIComponent(url), true);
          req.responseType = "blob";

          req.onload = () => {
            const blob = req.response;
            resolve(URL.createObjectURL(blob));
            // ...
          };

          req.send();
        } catch (e) {
          reject(e);
        }
      });
    },
    calculateLengthOfFile(url) {
      return new Promise((resolve, reject) => {
        try {
          const req = new XMLHttpRequest();
          req.open("GET", decodeURIComponent(url), true);
          req.responseType = "blob";

          req.onload = () => {
            const blob = req.response;
            var fileSize = req.getResponseHeader("Content-Length");
            var megabytes = fileSize / (1024 * 1024);
            resolve(megabytes);
            // ...
          };

          req.send();
        } catch (e) {
          reject(e);
        }
      });
    },
  },
  watch: {
    filePath() {
      switch (this.type) {
        case "DOCX":
        case "XLSX":
        case "PPTX":
        case "XLSM":
        case "RTF":
          this.fileSourcePath = OFFICE_PREVIEW_PATH_URL + this.filePath;
          this.calculateLengthOfFile(this.filePath).then((lengthOfFile) => {
            if(lengthOfFile>2)
            {
            EventBus.$emit("toast", {
              title: "Error",
              message:
                "The file size exceeds the limit for viewing",
              variant: "warning",
            });
          }
          }).catch(()=>{
            EventBus.$emit("toast", {
              title: "Error",
              message:
                "Something went wrong. Can you retry again or contact the Product Management team at productsupport@areteir.com",
              variant: "danger",
            });
          });
          break;
        default:
          this.createObjectUrlFromBinary(this.filePath).then((blobUrl) => {
            this.fileSourcePath = blobUrl;
          });
      }
      this.isModalVisible = this.isVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
.p-dialog-header-close {
  color: var(--blank-100) !important;
  width: 12px !important;
  height: 12px !important;
}
.file-previewer-dialog-header {
  color: var(--text-color) !important;
  font-size: 20px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.download-button {
  width: 103px;
  height: 32px;
}
.modal-body {
  height: 500px !important;
}
</style>